<template>
  <div class="plugin-wrap swiper_tab-wrap layout" v-if="config && Array.isArray(config.nodes) && config.nodes.length">
    <div class="ms-row collapsed">
      <div class="col-xs-12">
        <div class="title">{{config.title}}</div>
      </div>
      <div class="col-xs-12 tab_wrap">
        <div class="tab-titles">
          <button :class="[activeIndex == index ? 'btn--primary' : 'btn']" v-for="(tab, index) in config.nodes" :key="index" @click="switchTab(index)">{{tab.name}}</button>
        </div>
        <div class="tab-bodies">
          <div class="tab-body" v-if="swiched">
            <CircleSwiper :source="config.nodes[activeIndex].list" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CircleSwiper from '@/components/CircleSwiper';

export default {
  name: 'SwiperTab',
  components: { CircleSwiper },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeIndex: 0,
      swiched: true
    }
  },
  created() {},
  methods: {
    switchTab(index) {
      this.swiched = false;
      this.activeIndex = index;
      this.$nextTick(() => {
        this.swiched = true;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  .swiper_tab-wrap {
    box-sizing: border-box; padding-top: 1rem;
    .title { display: block; font-size: 2.1875rem; color: #000; text-align: center; margin-top: 5rem; }
    .tab_wrap {
      display: flex; flex-direction: column; margin-top: 2rem;
      .tab-titles {
        display: flex; justify-content: center; align-items: center; flex-wrap: wrap;
        button {
          margin: 0 .3125rem;
          &:first-child { margin-left: 0; }
        }
      }
    }
  }

  @media screen and (min-width: 48em) {
    .swiper_tab-wrap {
      .title { font-size: 2.5rem; margin-top: 6.125rem; line-height: 3rem; }
    }
  }
  @media screen and (min-width: 64em) {
    .swiper_tab-wrap {
      .title { font-size: 3.125rem; margin-top: 5.5625rem; }
    }
  }
</style>